// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sale-form-container{
    width:100%;
    height:100%;
    display: flex;
    flex-direction: column;
    align-items: center;

}

.sale-form-container form{
    width:60%;
    text-align: left;
    background-color: #fff;
    padding:50px;
}

.sale-form-container form button{
    padding:20px;
    cursor: pointer;
    font-family: 'Poppins',sans-serif;

}

.sale-form-container form button:hover{
    background-color: #e42727;
}

.sale-input-group{
    width:100%;
    margin:20px 0px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.sale-input-group label{
    font-family: 'Poppins',sans-serif;
    font-size: 16px;
    width:30%;

}
.sale-input-group input{
    margin-right: 0px;
    margin-left: auto;
    height:30px;
    width:70%;
}
.sale-input-group select {
    margin-right: 0px;
    margin-left: auto;
    height: 30px;
    width: 70%;
}

.manage-sale-container{
    width: 60%;
    height: 100%;
    margin:0 20%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.manage-sale-container form{
    width: 100%;
    height:100%;
    overflow: scroll;
        text-align: left;
        background-color: #fff;
        padding: 50px;
        
}

.manage-sale-container button{
        padding: 20px;
        cursor: pointer;
        font-family: 'Poppins', sans-serif;
}

.manage-sale-container button:hover{
    background-color: #e42727;
}


@media screen and (max-width:768px){
    .manage-sale-container{
        width:100%;
        margin:20px auto;
    }
.sale-input-group {
    width: 100%;
    margin: 20px 0px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

  .manage-sale-container form {
      width: 100%;
      height: 100%;
      overflow: scroll;
      text-align: left;
      background-color: #fff;
      padding: 10px;
      margin:20px 0px;

  }
  .sale-form-container {
    width:100%;
    margin:20px auto;
  }
  .content{
    width:80%;
    margin:0 auto;
  }

  .sale-form-container form{
    width:100%;
    padding:10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Styles/SaleForm.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;;AAEvB;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,iCAAiC;;AAErC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,iCAAiC;IACjC,eAAe;IACf,SAAS;;AAEb;AACA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;IACX,SAAS;AACb;AACA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,gBAAgB;QACZ,gBAAgB;QAChB,sBAAsB;QACtB,aAAa;;AAErB;;AAEA;QACQ,aAAa;QACb,eAAe;QACf,kCAAkC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA;IACI;QACI,UAAU;QACV,gBAAgB;IACpB;AACJ;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;EAEE;MACI,WAAW;MACX,YAAY;MACZ,gBAAgB;MAChB,gBAAgB;MAChB,sBAAsB;MACtB,aAAa;MACb,eAAe;;EAEnB;EACA;IACE,UAAU;IACV,gBAAgB;EAClB;EACA;IACE,SAAS;IACT,aAAa;EACf;;EAEA;IACE,UAAU;IACV,YAAY;EACd;AACF","sourcesContent":[".sale-form-container{\n    width:100%;\n    height:100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n}\n\n.sale-form-container form{\n    width:60%;\n    text-align: left;\n    background-color: #fff;\n    padding:50px;\n}\n\n.sale-form-container form button{\n    padding:20px;\n    cursor: pointer;\n    font-family: 'Poppins',sans-serif;\n\n}\n\n.sale-form-container form button:hover{\n    background-color: #e42727;\n}\n\n.sale-input-group{\n    width:100%;\n    margin:20px 0px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.sale-input-group label{\n    font-family: 'Poppins',sans-serif;\n    font-size: 16px;\n    width:30%;\n\n}\n.sale-input-group input{\n    margin-right: 0px;\n    margin-left: auto;\n    height:30px;\n    width:70%;\n}\n.sale-input-group select {\n    margin-right: 0px;\n    margin-left: auto;\n    height: 30px;\n    width: 70%;\n}\n\n.manage-sale-container{\n    width: 60%;\n    height: 100%;\n    margin:0 20%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.manage-sale-container form{\n    width: 100%;\n    height:100%;\n    overflow: scroll;\n        text-align: left;\n        background-color: #fff;\n        padding: 50px;\n        \n}\n\n.manage-sale-container button{\n        padding: 20px;\n        cursor: pointer;\n        font-family: 'Poppins', sans-serif;\n}\n\n.manage-sale-container button:hover{\n    background-color: #e42727;\n}\n\n\n@media screen and (max-width:768px){\n    .manage-sale-container{\n        width:100%;\n        margin:20px auto;\n    }\n.sale-input-group {\n    width: 100%;\n    margin: 20px 0px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n  .manage-sale-container form {\n      width: 100%;\n      height: 100%;\n      overflow: scroll;\n      text-align: left;\n      background-color: #fff;\n      padding: 10px;\n      margin:20px 0px;\n\n  }\n  .sale-form-container {\n    width:100%;\n    margin:20px auto;\n  }\n  .content{\n    width:80%;\n    margin:0 auto;\n  }\n\n  .sale-form-container form{\n    width:100%;\n    padding:10px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
